export default __webpack_public_path__ + "static/googleContactsLogo-187777faa2ca0342931a3c5125ceb9d7.svg";